import { Component, Injectable, QueryList, ViewChildren } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Subscription } from "rxjs/internal/Subscription";
import { Utils } from '../../utils';
import { SlideshowService } from "../slideshow.service";

@Injectable({
    providedIn: 'root',
})
export class SlideNavService {
    placeholder = '';
    loading = true;
    slidesLoadedSubscription: Subscription;

    constructor(
        public utils: Utils,
        public slideshow: SlideshowService, 
        public dialog: MatDialog
    ) {
        this.slidesLoadedSubscription = this.slideshow.slidesComplete.subscribe(() => {
            this.loading = false;
            this.slidesLoadedSubscription.unsubscribe();
        });
    }

    getContent(slide) {
        let items = slide.content;
        let content = [];
        if( this.slideshow.quiz ) {
            items = slide.feedback;
        }
        for(var i = 0; i < items.length; i++) {
            content.push(items[i].text);
        }
        return content.join('. ');
    }
    
    getSrc(images) {
        if( !images[0].hasOwnProperty('url') ) {
            return '';
        }
        const img = images[0];
        let src = img.url;
        if( img.hasOwnProperty('sizes') && img.sizes.hasOwnProperty('thumbnail') ) {
            src = img.sizes.thumbnail.url;
        }
        return src;
    }

    openDialog(oldIndex, newIndex, slide) {
        let dialog = this.dialog.open(TeaserDialog);
        dialog.afterClosed().subscribe(cancel => {
            if( cancel ) {
                this.slideshow.slides.splice(newIndex, 1);
                this.slideshow.slides.splice(oldIndex, 0, slide);
                this.slideshow.slides = [].concat(this.slideshow.slides);
                this.slideshow.setSlideOrder();
            }
        });
    }

    navigate(slide) {
        const index = this.slideshow.slides.indexOf(slide);
        if( index === -1 ) {
            return;
        }
        this.slideshow.setSlide(index);
    }
    
    findAncestor (el, className) {
        while ((el = el.parentElement) && el.className.indexOf(className) === -1);
        return el;
    }

    dragStart(e) {
        let slideEl = e.target;
        if( slideEl.className.indexOf('slide') === -1 ) {
            slideEl = this.findAncestor(e.target, 'slide');
        }
        this.placeholder = slideEl.innerHTML;
    }

    drop(viewSlides, e) {
        const startSlide = viewSlides.toArray().shift();
        const eIndex = parseInt(startSlide.nativeElement.dataset.index) + e.index;
        this.placeholder = '';
        let oldIndex = e.data;
        let newIndex = eIndex> oldIndex && eIndex!== 0 ? eIndex-1 : eIndex;
        if( oldIndex != newIndex ) {
            let slides = this.slideshow.slides;
            let slide = slides[oldIndex];
            let lastIndex = slides.length - 1;
            if( newIndex === 0 && slides[0].intro ) {
                newIndex = 1;
            }
            if( newIndex === lastIndex && slides[lastIndex].outro ) {
                newIndex = lastIndex - 1;
            }
            slides.splice(oldIndex, 1);
            slides.splice(newIndex, 0, slide);
            this.slideshow.slides = [].concat(slides);
            this.slideshow.setSlideOrder();
            if( slide.teaser ) {
                this.openDialog(oldIndex, newIndex, slide);
            }
        }
    }

    getSlideNumber(slide) {
        if( slide.intro ) {
            return 'IN';
        }
        if( this.slideshow.quiz && slide.outro ) {
            return 'R';
        }
        const index = this.slideshow.slides.indexOf(slide);
        if( !this.slideshow.assignment.intro ) {
            return index + 1;
        }
        return index;
    }

    ngOnDestroy() {
        if( this.slidesLoadedSubscription ) {
            this.slidesLoadedSubscription.unsubscribe();
        }
    }
}

@Component({
    selector: 'teaser-dialog',
    template: `
        <h2 mat-dialog-title>Teaser</h2>
        <mat-dialog-content>This slide contains teaser text. Are you sure you want to move it?</mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="true">Cancel</button>
            <button class="button" mat-dialog-close>Yes</button>
        </mat-dialog-actions>`,
})
export class TeaserDialog {}